import { render, staticRenderFns } from "./PersonnelRecordDetailsTabPhysicals.vue?vue&type=template&id=093b0bb6"
import script from "./PersonnelRecordDetailsTabPhysicals.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabPhysicals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports